import ICodeError, { instanceOfICodeError } from "./ICodeError"
import IUserIdentity, { instanceOfIUserIdentity } from "./IUserIdentity"
import Nullable from "./utils/Nullable"

interface IErrorReport{
    url: string,
    user: Nullable<IUserIdentity>,
    errors: ICodeError[]
}

export const instanceOfIErrorReport = (object: any) : object is IErrorReport => {
    if(typeof object.user === 'undefined' || (object.user !== null && !instanceOfIUserIdentity(object.user))){
        return false
    }

    if(typeof object.errors !== 'undefined' && typeof object.errors[0] !== 'undefined'){
        for(let error of object.errors){
            if(!instanceOfICodeError(error)){
                return false
            }
        }
    }

    return 'url' in object &&
            'user' in object &&
            'errors' in object
}

export default IErrorReport